// import sidebar from '@/config/sidebars/geobooster'
// import createVueApp from '@/common/create_app'

Styxie.Initializers.MobileCheckins = {
  // Phase 4: Moments Index
  // index: async(props) => { ... }

  // Phase 4: Moment Create
  // new: async(props) => { ... }

  // Phase 4: Moment Edit
  // edit: async(props) => { ... }
}
